import { Link } from 'react-router-dom';
import './AboutPage.css';

function ImageErrorPage() {
  return (
    <div className="about-page">
      <nav className="about-nav">
        <Link to="/" className="back-btn">← Back to Home</Link>
        <h1 className="about-logo">PET PALETTE USA</h1>
      </nav>

      <div className="about-container">
        <section className="about-section">
          <h2>Image Upload Error</h2>
          <p className="error-message">
            ERROR: Cannot read "image.png" (this model does not support image input).
          </p>
          <p>
            The AI model currently being used does not support processing or reading image files. 
            This is a limitation of the model itself, not a problem with your image or the website.
          </p>
          <p>
            To resolve this issue, please:
          </p>
          <ul>
            <li>Use a text-based input method instead of uploading images</li>
            <li>Contact support if you believe this is an error</li>
            <li>Try again later as model capabilities may be updated</li>
          </ul>
          <p>
            If you have any questions, please reach out to us at <strong>support@petpaletteusa.com</strong>.
          </p>
        </section>
      </div>

      <footer className="about-footer">
        <p>© {new Date().getFullYear()} Pet Palette USA. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default ImageErrorPage;
